module.exports = __webpack_public_path__ + "static/media/opiniao_comprador_7.201c5abd.png";